var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m31.17164.17021l2.78909,6.78364,6.76709-2.83636-.01891,7.32727,7.32727-.01891-2.83637,6.76709,6.80018,2.80564-5.2,5.17164,5.2,5.17164-6.78363,2.78909,2.83637,6.76709-7.32727-.01891.01891,7.32727-6.76709-2.83637-2.80564,6.80018-5.17164-5.2-5.17164,5.2-2.78909-6.78363-6.76709,2.83637.01891-7.32727-7.32727.01891,2.83636-6.76709-6.80018-2.80564,5.2-5.17164L0,20.99858l6.78364-2.78909-2.83636-6.76709,7.32727.01891-.01891-7.32727,6.76709,2.83636L20.82836.17021l5.17164,5.2L31.17164.17021Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m28.3827,26.37345l7.38164-7.38163c.58068-.62226.54698-1.59745-.07529-2.17813-.59159-.55207-1.50941-.55257-2.10162-.00115l-7.384,7.38163-7.38164-7.38163c-.6229-.58-1.59804-.54524-2.17804.07766-.55143.5922-.55093,1.51001.00114,2.10161l7.38164,7.38163-7.37928,7.38636c-.6229.58001-.65767,1.55515-.07767,2.17805.58002.6229,1.55516.65767,2.17806.07766.02638-.02457.05192-.05007.07651-.07643l7.37928-7.37928,7.384,7.38164c.6229.58001,1.59804.54523,2.17804-.07766.55143-.59221.55093-1.51002-.00114-2.10162l-7.38164-7.38873Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVerified);
export default __webpack_public_path__ + "static/media/not-verified.95492a67c827dcffc66240d10a2a41e1.svg";
export { ForwardRef as ReactComponent };